/* CLIKART Product page: gallery, zoom, sticky ATC, share; Collection: filters drawer, view toggle */
(function () {
  'use strict';

  /* ---- Gallery (works standalone; media-gallery.setActiveMedia is patched to sync) ---- */
  function initGallery(g) {
    if (g.dataset.ckInit) return; g.dataset.ckInit = '1';
    const slides = [...g.querySelectorAll('[data-ck-slide]')];
    const thumbs = [...g.querySelectorAll('[data-ck-thumb]')];
    const cur = g.querySelector('[data-ck-gcur]');
    let i = 0;
    const go = (n) => {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      thumbs[i]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      if (cur) cur.textContent = i + 1;
    };
    thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
    g.querySelector('[data-ck-gprev]')?.addEventListener('click', () => go(i - 1));
    g.querySelector('[data-ck-gnext]')?.addEventListener('click', () => go(i + 1));
    // variant change → theme calls setActiveMedia(mediaId)
    g.setActiveMedia = (mediaId) => { const k = slides.findIndex(s => s.dataset.mediaId === mediaId); if (k > -1) go(k); };
    // swipe
    let x0 = null;
    g.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    g.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); });
    // zoom
    const zoom = document.querySelector('[data-ck-zoom]');
    if (zoom) {
      g.querySelectorAll('.ck-gallery__slide img').forEach(img => img.addEventListener('click', () => {
        zoom.querySelector('img').src = img.dataset.zoom || img.currentSrc || img.src;
        zoom.classList.add('is-open'); document.body.style.overflow = 'hidden';
      }));
      const close = () => { zoom.classList.remove('is-open'); document.body.style.overflow = ''; };
      zoom.querySelector('[data-ck-zoom-close]').addEventListener('click', close);
      zoom.addEventListener('click', e => { if (e.target === zoom) close(); });
      document.addEventListener('keyup', e => { if (e.key === 'Escape') close(); });
    }
  }

  /* ---- Sticky ATC ---- */
  function initSticky(root) {
    const bar = root.querySelector('[data-ck-sticky]'); if (!bar || bar.dataset.ckInit) return; bar.dataset.ckInit = '1';
    const buy = root.querySelector('.ck-buy');
    const btn = bar.querySelector('[data-ck-sticky-add]');
    const mainBtn = root.querySelector('.ck-buy [name="add"]');
    btn?.addEventListener('click', () => mainBtn?.click());
    if (!buy || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([en]) => {
      bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      if (mainBtn) { btn.disabled = mainBtn.disabled; btn.textContent = mainBtn.querySelector('span')?.textContent.trim() || 'Add to cart'; }
    }, { threshold: 0 }).observe(buy);
  }

  /* ---- Color swatches → gallery image + live title color ---- */
  function initColor(root) {
    const fs = root.querySelector('[data-ck-color-fieldset]'); if (!fs || fs.dataset.ckInit) return; fs.dataset.ckInit = '1';
    const gallery = root.querySelector('[data-ck-gallery]');
    const titles = root.querySelectorAll('[data-ck-title-color]');
    const apply = (input) => {
      if (!input) return;
      titles.forEach(t => t.textContent = input.dataset.ckColor || input.value);
      const legend = fs.querySelector('[data-selected-value]'); if (legend) legend.textContent = input.value;
      const mediaId = input.dataset.ckMedia;
      if (mediaId && gallery?.setActiveMedia) gallery.setActiveMedia(mediaId);
    };
    fs.addEventListener('change', e => { if (e.target.matches('input[type=radio]')) apply(e.target); });
    apply(fs.querySelector('input[type=radio]:checked'));
  }

  /* ---- "See full specifications" → open tab & scroll ---- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ck-tab-jump]'); if (!b) return;
    const tab = document.querySelector(`[data-ck-tab="${b.dataset.ckTabJump}"]`); if (!tab) return;
    tab.click(); tab.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---- Quantity (fallback if theme's quantity-input isn't defined) ---- */
  function initQty(root) {
    root.querySelectorAll('.ck-qty').forEach(q => {
      if (q.dataset.ckInit) return; q.dataset.ckInit = '1';
      const inp = q.querySelector('input');
      q.querySelector('[name="minus"]').addEventListener('click', () => { inp.value = Math.max(1, (parseInt(inp.value) || 1) - 1); inp.dispatchEvent(new Event('change', { bubbles: true })); });
      q.querySelector('[name="plus"]').addEventListener('click', () => { inp.value = (parseInt(inp.value) || 1) + 1; inp.dispatchEvent(new Event('change', { bubbles: true })); });
    });
  }

  /* ---- Share ---- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-ck-share]'); if (!b) return;
    const data = { title: document.title, url: location.href };
    if (navigator.share) { try { await navigator.share(data); } catch (_) {} }
    else { await navigator.clipboard?.writeText(location.href); b.textContent = 'Link copied ✓'; setTimeout(() => location.reload(), 1200); }
  });

  /* ---- Collection: filters drawer + view toggle ---- */
  function initCollection(root) {
    if (root.dataset.ckInit) return; root.dataset.ckInit = '1';
    const filters = root.querySelector('.ck-filters');
    root.querySelectorAll('[data-ck-open-filters]').forEach(b => b.addEventListener('click', () => { filters?.classList.add('is-open'); document.body.style.overflow = 'hidden'; }));
    root.querySelectorAll('[data-ck-close-filters]').forEach(b => b.addEventListener('click', () => { filters?.classList.remove('is-open'); document.body.style.overflow = ''; }));
    const list = root.querySelector('.ck-plist');
    root.querySelectorAll('[data-ck-view]').forEach(b => b.addEventListener('click', () => {
      root.querySelectorAll('[data-ck-view]').forEach(x => x.classList.toggle('is-active', x === b));
      list?.classList.toggle('is-list', b.dataset.ckView === 'list');
      try { localStorage.setItem('ck-view', b.dataset.ckView); } catch (_) {}
    }));
    try { const v = localStorage.getItem('ck-view'); if (v) root.querySelector(`[data-ck-view="${v}"]`)?.click(); } catch (_) {}
    // sort select → submit filters form (theme facet-filters-form listens to change)
    root.querySelector('[data-ck-sort]')?.addEventListener('change', (e) => {
      const url = new URL(location.href); url.searchParams.set('sort_by', e.target.value); location.href = url.toString();
    });
  }

  function boot() {
    document.querySelectorAll('[data-ck-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-ck-product]').forEach(r => { initSticky(r); initColor(r); if (!customElements.get('quantity-input')) initQty(r); });
    document.querySelectorAll('[data-ck-collection]').forEach(initCollection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
